import React from "react";
import css from "./index.module.scss";
import { useInView, animated } from "@react-spring/web";
import { useTranslation } from "react-i18next";

const mList = [
  { title: "$singlee_xw6", pic: require("assets/xwyd/m1.png") },
  { title: "$singlee_xw7", pic: require("assets/xwyd/m2.png") },
  { title: "$singlee_xw8", pic: require("assets/xwyd/m3.png") },
  { title: "$singlee_xw9", pic: require("assets/xwyd/m4.png") },
  { title: "$singlee_xw10", pic: require("assets/xwyd/m5.png") },
  { title: "$singlee_xw11", pic: require("assets/xwyd/m6.png") },
  { title: "$singlee_xw12", pic: require("assets/xwyd/m7.png") },
  { title: "$singlee_xw13", pic: require("assets/xwyd/m8.png") },
];

const bList = [
  { title: "$singlee_xw15", pic: require("assets/xwyd/b5.png") },
  { title: "$singlee_xw16", pic: require("assets/xwyd/b6.png") },
  { title: "$singlee_xw17", pic: require("assets/xwyd/b7.png") },
  { title: "$singlee_xw18", pic: require("assets/xwyd/b8.png") },
  { title: "$singlee_xw19", pic: require("assets/xwyd/b9.png") },
  { title: "$singlee_xw20", pic: require("assets/xwyd/b10.png") },
  { title: "$singlee_xw21", pic: require("assets/xwyd/b11.png") },
  { title: "$singlee_xw22", pic: require("assets/xwyd/b12.png") },
  { title: "$singlee_xw23", pic: require("assets/xwyd/b13.png") },
  { title: "$singlee_xw24", pic: require("assets/xwyd/b14.png") },
];

function Index() {
  const { t } = useTranslation();

  const [firtst1Ref, firstRefStyle1] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [firtst2Ref, firstRefStyle2] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [firtst3Ref, firstRefStyle3] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [secondRef, secondRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
      config: { duration: 500 },
    }),
    { threshold: 0.3, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [thirdRef, thirdRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.3, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [fourthRef, fourthRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.4, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  return (
    <div className={css.cloudcontain}>
      <div className={css.maintitle}>{t("小微云店")}</div>

      <div className={css.first}>
        <div className={css.inner}>
          <div className={`${css.subtitle} ${css.none}`}>
            {t("$singlee_pay1")}
          </div>
          <div className={css.secondtitle}>{t("$singlee_xw1")}</div>
          <div className={css.content}>
            <div ref={firtst1Ref}>
              <animated.div className={css.t1} style={firstRefStyle1}>
                <div className={css.name}>{t("$singlee_xw2")}</div>
              </animated.div>
            </div>
            <div ref={firtst2Ref}>
              <animated.div className={css.t2} style={firstRefStyle2}>
                <div className={css.name}>{t("$singlee_xw3")}</div>
              </animated.div>
            </div>
            <div ref={firtst3Ref}>
              <animated.div className={css.t3} style={firstRefStyle3}>
                <div className={css.name}>{t("$singlee_xw4")}</div>
              </animated.div>
            </div>
          </div>
        </div>
      </div>

      <div className={css.second} ref={secondRef}>
        <animated.div className={css.inner} style={secondRefStyle}>
          <div className={`${css.subtitle} ${css.none}`}>
            {t("$singlee_xw5")}
          </div>
          <div className={css.content}>
            {mList.map((item, index) => {
              return (
                <div className={css.item} key={index}>
                  <div className={css.pic}>
                    <img src={item.pic} alt="" />
                  </div>
                  <div className={css.title}>{t(item.title)}</div>
                </div>
              );
            })}
          </div>
        </animated.div>
      </div>

      <div className={css.third} ref={thirdRef}>
        <animated.div className={css.inner} style={thirdRefStyle}>
          <div className={css.subtitle}>{t("适用场景")}</div>
          <div className={css.secondtitle} style={{ marginTop: "20px" }}>
            {t("$singlee_xw14")}
          </div>
          <div className={css.content}>
            {bList.map((item, index) => {
              return (
                <div className={css.item} key={index}>
                  <div className={css.pic}>
                    <img src={item.pic} alt="" />
                  </div>
                  <div className={css.title}>{t(item.title)}</div>
                </div>
              );
            })}
          </div>
        </animated.div>
      </div>

      <div className={css.fourth} ref={fourthRef}>
        <div className={css.inner}>
          <div className={css.subtitle}>{t("部分合作案例")}</div>
          <animated.div className={css.box} style={fourthRefStyle}>
            <div className={css.item}>{t("$singlee_xw25")}</div>
            <div className={css.item}>{t("$singlee_xw26")}</div>
            <div className={css.item}>{t("$singlee_xw27")}</div>
            <div className={css.item}>{t("$singlee_xw28")}</div>
          </animated.div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(Index);
